module.exports = __webpack_public_path__ + "img/isci.29f637a4.png";